import { Box, Paper, Typography, styled, Stack } from '@mui/material';
import React from 'react';
import TransgenderIcon from '@mui/icons-material/Transgender';
import BarChartIcon from '@mui/icons-material/BarChart';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

const IconWrapper = styled("Box")({
  backgroundColor: "#f2f2f2",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "46px",
  height: "37px"
});

export default function StdeuntsTypeSingleTeacher({ teacher }) {
  const lang = Cookies.get("i18next") || "en";
  const { t } = useTranslation();

  return (
    <Paper sx={{ padding: { xs: "24px 16px", md: "32px 24px" }, marginY: "30px" }}>
      <Typography sx={{ fontSize: "22px", marginBottom: "18px" }}>
        {t('typeStudent')}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={3}
        alignItems="flex-start"
      >
        {/* Gender */}
        <Stack direction="row" spacing={2} alignItems="center">
          <IconWrapper><TransgenderIcon /></IconWrapper>
          <Box>
            <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
              {t('genderStudents')}
            </Typography>
            <Typography sx={{ color: "#878787", fontSize: "14px" }}>
              {t(teacher?.favStdGender)}
            </Typography>
          </Box>
        </Stack>

        {/* Levels */}
        <Stack direction="row" spacing={2} alignItems="center">
          <IconWrapper><BarChartIcon /></IconWrapper>
          <Box>
            <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
              {t('levelStudents')}
            </Typography>
            <Typography sx={{ color: "#878787", fontSize: "14px" }}>
              {lang === "ar"
                ? teacher?.TeacherLevels?.map(item => item?.Level?.titleAR).join("، ")
                : teacher?.TeacherLevels?.map(item => item?.Level?.titleEN).join(", ")
              }
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
}
